import React from 'react'
import { Outlet } from 'react-router-dom'

const ProjectDeptStatMngPage = () => {
    return (
        <div>
            <Outlet />
        </div>
    )
}

export default ProjectDeptStatMngPage